import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  alreadyInCollection: {
    id: 'studio.XTIljc',
    defaultMessage: 'App is already in collection',
  },
  addToCollection: {
    id: 'studio.ub1kHa',
    defaultMessage: 'Add to collection',
  },
  cancel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  error: {
    id: 'studio.MnBkWQ',
    defaultMessage: 'Something went wrong when adding app to collection',
  },
  noCollections: {
    id: 'studio.ScGnAZ',
    defaultMessage: 'You do not have any collections yet.',
  },
  createCollection: {
    id: 'studio.qkFwbV',
    defaultMessage: 'Create a collection',
  },
});
